var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"jurisdiction-navigation"},[_c('span',{staticClass:"jurisdiction-navigation-item",class:{ disabled: _vm.currentJurisdictionIndex === 0 },on:{"click":function($event){return _vm.$router.push({
      name: 'JurisdictionDetail',
      params: {
        id: _vm.jurisdictionsList[_vm.currentJurisdictionIndex - 1].id,
      }
    })}}},[_c('i',{staticClass:"bi bi-caret-left-fill"}),_vm._v(" "+_vm._s(_vm.$t('words.previous'))+" ")]),_c('span',{staticClass:"jurisdiction-navigation-item",class:{ disabled: _vm.currentJurisdictionIndex === _vm.jurisdictionsList.length - 1 },on:{"click":function($event){return _vm.$router.push({
      name: 'JurisdictionDetail',
      params: {
        id: _vm.jurisdictionsList[_vm.currentJurisdictionIndex + 1].id,
      }
    })}}},[_vm._v(" "+_vm._s(_vm.$t('words.next'))+" "),_c('i',{staticClass:"bi bi-caret-right-fill"})])])}
var staticRenderFns = []

export { render, staticRenderFns }